import { STORAGE_KEY } from './const';
import {
    buildCookie,
    isVisitorIdValid,
    mintVisitorId,
    readVisitorIdCookie,
} from './domain';

const storage = (): Storage | null => {
    try {
        return window.localStorage;
    } catch (e) {
        // приватный режим и «блокировать данные сайтов» бросают на доступе
        return null;
    }
};

const writeCookie = (id: string): void => {
    document.cookie = buildCookie(id, location.protocol === 'https:');
};

const readMirror = (): string => {
    try {
        const mirrored = storage()?.getItem(STORAGE_KEY) ?? null;

        return isVisitorIdValid(mirrored) ? mirrored : '';
    } catch (e) {
        return '';
    }
};

const writeMirror = (id: string): void => {
    try {
        storage()?.setItem(STORAGE_KEY, id);
    } catch (e) {
        // хранилище переполнено или запрещено — кука уже поставлена
    }
};

/**
 * Идентификатор браузера для сплит-тестов: поднимает существующий или заводит
 * новый, продлевая куку. Зовётся на каждой странице из general.js.
 *
 * Плечо по нему выводит СЕРВЕР (`Romantic\Tool\Ab\Split`), читая куку при
 * создании открытки. Клиент только носит id: так веса меняются из админки, без
 * выката JS, и правило назначения живёт в одном месте.
 *
 * Зеркало здесь читается СИНХРОННО — в отличие от соседнего токена владения,
 * который откладывает то же чтение до простоя. Разница не в цене обращения, а в
 * том, как часто по нему приходится идти: `card_owner` у анонима из поискового
 * трафика отсутствует на КАЖДОЙ странице (большинство посетителей открытку не
 * создаёт), а куку с id мы ставим тут же на первой, поэтому в ветку без куки
 * браузер заходит один раз за всё время. Откладывать разовое чтение незачем, а
 * отложив, мы получили бы окно, в котором быстрый посетитель успевает отправить
 * форму раньше, чем появится кука, — и выпадал бы из эксперимента именно тот,
 * кто действует быстро, то есть смещённо.
 */
export const ensureVisitorId = (): string => {
    const fromCookie = readVisitorIdCookie(document.cookie);

    if (fromCookie) {
        // Продление дёшево (одна запись в document.cookie) и обязательно:
        // Safari режет JS-куки до недели с последнего захода. Зеркало при этом
        // не безусловная страховка — см. TTL_DAYS.
        writeCookie(fromCookie);

        return fromCookie;
    }

    const id = readMirror() || mintVisitorId();

    writeCookie(id);
    writeMirror(id);

    return id;
};
